module.exports = __webpack_public_path__ + "img/partner_large.b36be4cf.png";